import { LazyModule, LazyAction } from 'owa-bundling';

export {
    BulkActionInformation,
    default as BulkActionStore,
} from './store/schema/BulkActionStateStore';
export { ComponentClass } from 'react';
export { default as isBulkActionInState } from './utils/isBulkActionInState';
export { default as isBulkActionValid } from './utils/isBulkActionValid';
export { default as BulkActionCustomDataBase } from './store/schema/BulkActionCustomDataBase';
export {
    default as BulkActionNotificationPayload,
} from 'owa-service/lib/contract/BulkActionNotificationPayload';
export { LazyAction, LazyModule } from 'owa-bundling';
export {
    default as BulkActionStateEnum,
    BulkActionStateServerEnum,
} from './store/schema/BulkActionStateEnum';

export { default as store } from './store/store';
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "BulkActions" */ './lazyIndex')
);

export let lazySubscribeToBulkActionNotification = new LazyAction(
    lazyModule,
    m => m.subscribeToBulkActionNotification
);
export let lazyOnBulkActionSubmitted = new LazyAction(lazyModule, m => m.onBulkActionSubmitted);
export let lazyfindBulkActionItemAction = new LazyAction(
    lazyModule,
    m => m.findBulkActionItemAction
);
export let lazyOnBulkActionCancel = new LazyAction(lazyModule, m => m.onBulkActionCancel);
export let lazyOnBulkActionHierarchyNotification = new LazyAction(
    lazyModule,
    m => m.onBulkActionHierarchyNotification
);
export let lazyOnBulkActionDismiss = new LazyAction(lazyModule, m => m.onBulkActionDismiss);
